<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end">
          <v-menu
            offset-y
            v-if="
              user.roleName != 'WAREHOUSE_MANAGER' &&
              user.roleName != 'WAREHOUSE_STAFF'
            "
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" v-bind="attrs" v-on="on">
                <v-icon>add_circle</v-icon>Add
              </v-btn>
            </template>
            <v-list>
              <v-list-tile @click="onRegister">
                <v-list-tile-content>
                  <v-list-tile-title>ADD NEW</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="success"
                :loading="buttonLoading"
                v-bind="attrs"
                v-on="on"
                ><v-icon>cloud_download</v-icon>Export</v-btn
              >
            </template>

            <v-list>
              <v-list-tile @click="exportAllOrderExcel()">
                <v-list-tile-content>
                  <v-list-tile-title>EXPORT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromOrderDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker
                  v-model="queryParams.fromOrderDate"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toOrderDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker
                  v-model="queryParams.toOrderDate"
                ></v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex sm3 v-if="checkRoleStatus() == ''">
              <v-select
                :items="orderStatusList"
                label="Choose Status ..."
                :hide-no-data="true"
                color="blue-grey lighten-2"
                item-text="label"
                item-value="value"
                menu-props="auto"
                v-model="queryParams.status"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-autocomplete
                v-model="queryParams.customerIds"
                :items="selectedCustomerList"
                label="Customer"
                @click="showCustomers()"
                item-text="name"
                item-value="id"
                multiple
                menu-props="auto"
                autocomplete
              ></v-autocomplete>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="issueNo"
                label="Issue No"
                type="text"
                v-model="queryParams.issueNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="orderNo"
                label="Order No"
                type="text"
                v-model="queryParams.orderNo"
              ></v-text-field>
            </v-flex>
            <v-flex
              sm3
              v-if="
                user.roleName != 'SALE_MANAGER' ||
                user.roleName != 'GENERAL_MANAGER'
              "
            >
              <v-text-field
                name="orderBy"
                label="Order By"
                type="text"
                v-model="queryParams.marketerName"
              ></v-text-field>
            </v-flex>
            <v-flex
              sm3
              v-if="this.checkUserShop() == '' && user.roleName != 'SALE'"
            >
              <v-select
                :items="shopList"
                label="Choose Shop..."
                item-text="name"
                menu-props="auto"
                item-value="id"
                v-model="queryParams.shopId"
              ></v-select>
            </v-flex>
            <v-flex sm3 v-if="checkUserWarehouse() == ''">
              <v-select
                :items="warehouseList"
                v-model="queryParams.warehouseId"
                label="Select Warehouse"
                item-text="name"
                item-value="id"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :must-sort="true"
            :headers="headers"
            :items="orderList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
          >
            <template slot="items" slot-scope="props">
              <td>
                <v-btn
                  flat
                  icon
                  color="blue lighten-2"
                  @click="onEdit(props.item)"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
                <v-btn
                  flat
                  icon
                  color="blue lighten-2"
                  @click="print(props.item.id)"
                >
                  <v-icon>print</v-icon>
                </v-btn>
              </td>
              <td>{{ props.item.orderStatus }}</td>
              <td>
                {{ props.item.orderDateInMilliSeconds | formatMsDate }}
              </td>
              <td>{{ props.item.issueNo }}</td>
              <td>{{ props.item.orderNo }}</td>
              <td>
                {{
                  props.item.estimateDeliveryDateInMilliSeconds | formatMsDate
                }}
              </td>
              <td>
                {{ props.item.csRequestDateInMilliSeconds | formatMsDate }}
              </td>
              <td>{{ props.item.customerDTO.name }}</td>
              <td>{{ props.item.phoneNo }}</td>
              <td>{{ props.item.cityDTO.name }}</td>
              <td>{{ props.item.townshipDTO.name }}</td>
              <td>{{ props.item.userDTO.username }}</td>
              <td>{{ props.item.warehouseName }}</td>
              <td>{{ props.item.deliveryAddress }}</td>
              <td>{{ props.item.billingAddress }}</td>
              <td style="text-align: right;">{{ props.item.discountAmount | decFormat(6) }}</td>
              <td style="text-align: right;">{{ props.item.totalAmount | decFormat(6) }}</td>
              <td>{{ props.item.updatedBy }}</td>
              <td>
                {{ props.item.updatedDateInMilliSeconds | formatMsDate }}
              </td>
              <td>{{ props.item.remark }}</td>
              <td>{{ props.item.adminRemark }}</td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- customer dialog -->
    <v-dialog v-model="showCustomerListDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-layout wrap>
            <v-flex xs12 sm6 md3>
              <v-text-field
                name="name"
                label="Customer Name"
                type="text"
                class="mr-1"
                v-model="customerQueryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <v-text-field
                name="code"
                label="Customer Code"
                type="text"
                class="mr-1"
                v-model="customerQueryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <v-text-field
                name="email"
                label="Customer Email"
                type="text"
                class="mr-1"
                v-model="customerQueryParams.email"
              ></v-text-field>
            </v-flex>
            <v-flex sm2>
              <v-btn outline color="primary" @click="onSearchCustomer">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <!-- Customer List Section -->
          <v-flex xs12 class="mt-1">
            <v-data-table
              v-model="selectedCustomerList"
              :headers="customerHeaders"
              :items="activeCustomerList"
              select-all
              class="elevation-1"
              :loading="showListLoading"
              :total-items="customerTotalRows"
              :rows-per-page-items="rowsPerPageItems"
              :pagination.sync="customerPagination"
              :must-sort="true"
            >
              <template slot="headers" slot-scope="props">
                <tr>
                  <th>
                    <v-checkbox
                      primary
                      hide-details
                      @click.native="toggleAll"
                      :input-value="props.all"
                      :indeterminate="props.indeterminate"
                    ></v-checkbox>
                  </th>
                  <th v-for="header in props.headers" :key="header.text">
                    {{ header.text }}
                  </th>
                </tr>
              </template>
              <template slot="items" slot-scope="props">
                <td>
                  <v-checkbox
                    primary
                    hide-details
                    :input-value="props.selected"
                    :value="props.item"
                    :indeterminate="props.indeterminate"
                    v-model="selectedCustomerList"
                    multiple
                  ></v-checkbox>
                </td>
                <td>
                  <a>{{ props.item.code }}</a>
                </td>
                <td>{{ props.item.name }}</td>
                <td>{{ props.item.email }}</td>
                <td>{{ props.item.phoneNo }}</td>
                <td>{{ props.item.creditLevel.name }}</td>
              </template>
            </v-data-table>
            <div class="text-xs-right">
              <v-btn color="primary" @click="setCustomer">Ok</v-btn>
            </div>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { commonService } from "../../services/common-service";
import { orderService } from "../../services/order-service";
import { warehouseService } from "../../services/warehouse-service";
import { shopService } from "../../services/shop-service";
import { customerService } from "../../services/customer-service";

export default {
  name: "OrderList",

  components: {},
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    buttonLoading: false,
    showFilters: false,
    issueDate: commonService.formatDate(
      new Date().toISOString().substr(0, 10),
      "YYYY-MM-DD"
    ),
    showListLoading: false,
    breadcrumbs: [
      {
        text: "Order Management ",
        disabled: true,
      },
      {
        text: "Order",
        disabled: true,
      },
    ],
    headers: [
      { text: "Action", value: "action", sortable: false },
      { text: "Status", value: "orderStatus" },
      { text: "Order Date", align: "left", value: "orderDate" },
      { text: "Issue No", value: "issueNo" },
      { text: "Order No", value: "orderNo" },
      { text: "Estimate Delivery Date", value: "estimateDeliveryDate" },
      { text: "Customer Request Date", value: "csRequestDate" },
      { text: "Customer Name", value: "customer.name" },
      { text: "Phone No", value: "phoneNo" },
      { text: "City", value: "city.name" },
      { text: "Township", value: "township.name" },
      { text: "Order Person", value: "user.username" },
      { text: "Warehouse Name", value: "warehouseName" },
      { text: "Delivery Address", value: "deliveryAddress" },
      { text: "Billing Address", value: "billingAddress" },
      { text: "Discount Amount", align: "right", value: "discountAmount" },
      { text: "Total Net Amount", align: "right", value: "totalAmount" },
      { text: "Updated By", value: "updatedBy" },
      { text: "Updated Date", value: "UpdatedDate" },
      { text: "Remark", value: "remark" },
      { text: "Admin Remark", value: "adminRemark" },
    ],
    customerHeaders: [
      { text: "Code", align: "left", value: "code" },
      { text: "Name", align: "left", value: "name" },
      { text: "Email", value: "email" },
      { text: "PhoneNo", value: "phoneNo" },
      { text: "Credit Level", value: "creditLevel", sortable: false },
    ],
    activeCustomerList: [],
    selectedCustomerList: [],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updatedDate",
      totalItems: 0,
    },
    customerPagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updatedDate",
      totalItems: 0,
    },
    orderStatusList: [
      { label: "----All----", value: "" },
      { label: "PENDING", value: "PENDING" },
      { label: "CONFIRM", value: "CONFIRM" },
      { label: "CANCEL", value: "CANCEL" },
    ],
    orderList: [],
    totalRows: 0,
    customerTotalRows: 0,
    showCustomerListDialog: false,
    queryParams: {
      fromOrderDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toOrderDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      issueNo: "",
      orderNo: "",
      customerName: "",
      marketerName: "",
      warehouseId: "",
      status: "",
      shopId: "",
      updateUserId: "",
      customerIds: [],
    },
    customerQueryParams: {
      name: "",
      code: "",
      email: "",
    },
    warehouseList: [],
    shopList: [],
  }),
  watch: {
    pagination: {
      handler() {
        this.getAllWarehouse();
        this.getOrderList();
      },
      deep: true,
    },
    customerPagination: {
      handler() {
        this.getActiveCustomer();
      },
      deep: true,
    },
  },
  created() {
    if (this.checkUserShop() == "" && this.user.roleName != "SALE") {
      this.getAllShop();
    }
    this.queryParams.shopId = this.checkUserShop();
    this.queryParams.warehouseId = this.checkUserWarehouse();
    this.queryParams.updateUserId = this.checkUpdateUser();
    this.queryParams.status = this.checkRoleStatus();

    //for deep linking
    if (this.$route.query.fromOrderDate) {
      this.queryParams.fromOrderDate = this.$route.query.fromOrderDate;
    }
    if (this.$route.query.toOrderDate) {
      this.queryParams.toOrderDate = this.$route.query.toOrderDate;
    }
    if (this.$route.query.issueNo) {
      this.queryParams.issueNo = this.$route.query.issueNo;
    }
    if (this.$route.query.orderNo) {
      this.queryParams.orderNo = this.$route.query.orderNo;
    }
    if (this.$route.query.customerName) {
      this.queryParams.customerName = this.$route.query.customerName;
    }
    if (this.$route.query.marketerName) {
      this.queryParams.marketerName = this.$route.query.marketerName;
    }
    if (this.$route.query.warehouseId) {
      this.queryParams.warehouseId = Number(this.$route.query.warehouseId);
    }
    if (this.$route.query.status) {
      this.queryParams.status = this.$route.query.status;
    }
    if (this.$route.query.shopId) {
      this.queryParams.shopId = Number(this.$route.query.shopId);
    }
    if (this.$route.query.updateUserId) {
      this.queryParams.updateUserId = Number(this.$route.query.updateUserId);
    }
    if (this.$route.query.customerIds) {
      if (Array.isArray(this.$route.query.customerIds)) {
        this.queryParams.customerIds = this.$route.query.customerIds.map(Number);
      } else {
        this.queryParams.customerIds = [ Number(this.$route.query.customerIds) ];
      }
      this.getActiveCustomer().then(()=>{
        this.selectedCustomerList = this.activeCustomerList.filter(customer => this.queryParams.customerIds.includes(customer.id));
      });
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.rowsPerPage) {
      this.pagination.rowsPerPage = this.$route.query.rowsPerPage;
    }

    this.getOrderList();
  },
  methods: {
    checkUserWarehouse() {
      if (
        this.user.roleName == "WAREHOUSE_MANAGER" ||
        this.user.roleName == "WAREHOUSE_STAFF" ||
        this.user.roleName == "BRANCH_ADMIN"
      ) {
        return this.user.warehouseId;
      } else return "";
    },
    checkUserShop() {
      if (
        this.user.role.roleName == "SALE_MANAGER" ||
        this.user.role.roleName == "GENERAL_MANAGER" ||
        this.user.roleName == "BRANCH_ADMIN"
      ) {
        return this.user.shopId;
      } else return "";
    },
    checkUpdateUser() {
      if (this.user.roleName == "SALE") {
        return this.user.id;
      } else return "";
    },
    checkRoleStatus() {
      if (
        this.user.roleName == "WAREHOUSE_MANAGER" ||
        this.user.roleName == "WAREHOUSE_STAFF"
      ) {
        return "PENDING";
      } else return "";
    },
    getAllShop() {
      shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
          let findAll = {
            id: "",
            name: "----All----",
          };
          this.shopList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch((err) => {
          console.log(err);
          if (err.response.data) {
            this.responseError = err.response.data.message;
          }
        });
    },
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.rowsPerPage = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "orders",
        query: this.queryParams,
      });
      this.getOrderList();
    },
    getOrderList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      orderService
        .getOrderList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.orderList = res.data.orderHeaderList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },

    onRegister() {
      this.$router.push("/order/new");
    },
    onEdit(order) {
      // go to details page
      this.$router.push("/order/" + order.id);
    },
    print(id) {
      this.isLoading = true;
      orderService
        .printInvoiceById(id)
        .then((res) => {
          var blob = res;
          orderService.showWindowDialog(blob, "order-" + id);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    getAllWarehouse() {
      if (
        this.user.roleName == "ADMIN" ||
        this.user.roleName == "SALE_MANAGER" ||
        this.user.roleName == "GENERAL_MANAGER" ||
        this.user.roleName == "SALE" ||
        this.user.roleName == "BRANCH_ADMIN"
      ) {
        warehouseService
          .getWarehousesByStatus("ACTIVE")
          .then((res) => {
            let obj = { name: "--ALL--", id: "" };
            this.warehouseList.push(obj);
            res.data.forEach((element) => {
              this.warehouseList.push(element);
            });
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    exportAllOrderExcel() {
      this.buttonLoading = true;
      orderService
        .exportOrderExcel(this.queryParams)
        .then((res) => {
          commonService.downloadE(res);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.buttonLoading = false;
        });
    },
    showCustomers() {
      // Clean query params
      this.queryParams.code = "";
      this.queryParams.name = "";
      this.queryParams.email = "";
      this.selectedCustomerList = [];
      this.getActiveCustomer().then(
        (this.showCustomerListDialog = !this.showCustomerListDialog)
      );
    },
    onSearchCustomer() {
      this.customerQueryParams.page = this.pagination.page;
      this.customerQueryParams.size = this.pagination.rowsPerPage;
      this.getActiveCustomer();
    },
    getActiveCustomer() {
      this.showListLoading = true;
      let order = this.customerPagination.descending ? "desc" : "asc";
      return customerService
        .getCustomers(
          this.customerQueryParams,
          this.customerPagination.page,
          this.customerPagination.rowsPerPage,
          this.customerPagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.activeCustomerList = res.data.customerList;
            this.customerTotalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    toggleAll() {
      if (this.selectedCustomerList.length) {
        this.selectedCustomerList = [];
      } else {
        this.selectedCustomerList = this.activeCustomerList.slice();
      }
    },
    setCustomer() {
      if (this.selectedCustomerList.length) {
        this.queryParams.customerIds = [];
        this.selectedCustomerList.forEach((element) => {
          if (!this.queryParams.customerIds.includes(element.id))
            this.queryParams.customerIds.push(element.id);
        });
      }
      this.showCustomerListDialog = !this.showCustomerListDialog;
    },
  },
};
</script>